import * as React from 'react';
import { FaBell, FaBuilding, FaCalendar, FaChartLine, FaDashcube, FaFile, FaHammer, FaHome, FaLock, FaPersonBooth, FaShoePrints, FaSign, FaUser } from "react-icons/fa";
import CustomPage from "../pages/custom";
import { default as DashboardPage } from "../pages/dashboard";
import { default as EntitiesPage } from "../pages/entities";
import FilePage from "../pages/file";
import EventsPage from "../pages/events";
import FilesPage from "../pages/files";
import { default as HomePage } from "../pages/home";
import InvitePage from "../pages/invite";
import LayoutEditorPage from "../pages/layout_editor";
import LoginPage from "../pages/login";
import NotificationsPage from "../pages/notifications";
import { default as ProfilePage } from "../pages/profile";
import SignupPage from "../pages/signup";
import ThemeDetailsPage from "../pages/theme_details";
import UsersPage from "../pages/users";
import AdminPage from "../pages/admin";
import RecoverPage from "../pages/recover";
import EntityPage from "../pages/entity_details";

export interface RouteProps{
    title: string; 
    key: string ; 
    icon?: React.ReactNode; 
    url: string;
    component: React.ReactNode; 
    private?: boolean;
    menu?: boolean;
    condition? : (data: {user: any; role: any;}) => boolean;
}
const routes : RouteProps[] = [
    {
        title: 'Login',
        key: 'login',
        icon: <FaLock />,
        url: "/login",
        component: <LoginPage />
    },
    {
        title: 'Ver arquivo',
        key: 'file',
        url: "/f/:fileId",
        component: <FilePage />
    },
    {
        title: 'Cadastro',
        key: 'signup',
        icon: <FaSign />,
        url: "/cadastrar",
        component: <SignupPage />
    },
    {
        title: 'Cadastro',
        key: 'signup-company',
        icon: <FaSign />,
        url: "/cadastrar/empresa",
        component: <SignupPage company />
    },
    {
        title: 'Convite',
        key: 'invite',
        url: "/convite/:key",
        component: <InvitePage />
    },
    {
        title: 'Início',
        key: 'home',
        icon: <FaHome />,
        url: "/",
        menu: true,
        private: true,
        component: <HomePage />
    },
    {
        title: 'Insights',
        key: 'insights',
        icon: <FaChartLine />,
        url: "/insights",
        menu: true,
        private: true,
        component: <DashboardPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Perfil',
        key: 'profile',
        icon: <FaUser />,
        url: "/perfil",
        menu: false,
        private: true,
        component: <ProfilePage />
    },
    {
        title: 'Usuários',
        key: 'users',
        icon: <FaPersonBooth />,
        url: "/usuarios",
        menu: true,
        private: true,
        component: <UsersPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Entidades',
        key: 'entities',
        icon: <FaBuilding />,
        url: "/entidades",
        menu: true,
        private: true,
        component: <EntitiesPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Entidade',
        key: 'entity',
        icon: <FaBuilding />,
        url: "/entidade/:id",
        private: true,
        component: <EntityPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Calendário',
        key: 'calendar',
        icon: <FaCalendar />,
        url: "/calendario",
        menu: true,
        private: true,
        component: <EventsPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Arquivos',
        key: 'files',
        icon: <FaFile />,
        url: "/arquivos",
        menu: true,
        private: true,
        component: <FilesPage />,
        condition: ({user, role}) => !!role
    },
    {
        title: 'Notificações',
        key: 'notifications',
        icon: <FaBell />,
        url: "/notificacoes",
        menu: true,
        private: true,
        component: <NotificationsPage />,
    },
    {
        title: 'Layout',
        key: 'layout_edit',
        icon: <FaShoePrints />,
        url: "/layout/novo",
        private: true,
        component: <LayoutEditorPage />
    },
    {
        title: 'Detalhes Pauta',
        key: 'theme_details',
        url: "/pauta/:id",
        private: true,
        component: <ThemeDetailsPage />
    },
    {
        title: 'Admin',
        key: 'admin',
        url: "/admin",
        icon: <FaHammer/>,
        private: true,
        menu: true,
        condition: ({user,role}) => user.email.endsWith("fridom.com.br"),
        component: <AdminPage />
    },
    {
        title: 'Custom Page',
        key: 'custom-page',
        url: "/:key",
        private: false,
        component: <CustomPage />
    },
    {
        title: "Recuperar senha",
        key: "recover",
        url: "/recuperacao/:key",
        component: <RecoverPage />,
    },
]

export default routes;